var exports = {
  "k": "xe564cbfb--795f8a--container",
  "n": "xe564cbfb--795f8a--link",
};

module.exports = exports;
